var _path, _path2, _path3, _path4, _line, _line2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 67.5C320 68.301 319.634 69.48 318.099 71.0664C316.548 72.6682 314.058 74.4059 310.502 76.1833C303.404 79.7311 292.874 83.0397 279.532 85.8604C252.913 91.4878 215.953 95 175 95C134.047 95 97.0871 91.4878 70.4684 85.8604C57.1263 83.0397 46.5956 79.7311 39.4975 76.1833C35.9415 74.4059 33.4517 72.6682 31.9013 71.0664C30.3658 69.48 30 68.301 30 67.5C30 66.699 30.3658 65.52 31.9013 63.9336C33.4517 62.3318 35.9415 60.5941 39.4975 58.8167C46.5956 55.2689 57.1263 51.9603 70.4684 49.1396C97.0871 43.5122 134.047 40 175 40C215.953 40 252.913 43.5122 279.532 49.1396C292.874 51.9603 303.404 55.2689 310.502 58.8167C314.058 60.5941 316.548 62.3318 318.099 63.9336C319.634 65.52 320 66.699 320 67.5Z",
    stroke: "currentColor",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4939 103C34.5709 103.087 34.6582 103.182 34.757 103.284C35.873 104.437 37.9254 105.935 41.2675 107.605C47.9238 110.932 58.075 114.156 71.2774 116.947C97.551 122.501 134.22 126 174.982 126C215.743 126 252.412 122.501 278.686 116.947C291.888 114.156 302.039 110.932 308.696 107.605C312.038 105.935 314.09 104.437 315.206 103.284C315.305 103.182 315.392 103.087 315.469 103H323.963C322.7 120.166 256.482 134 174.982 134C93.481 134 27.2636 120.166 26 103H34.4939Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4939 137C34.5709 137.087 34.6582 137.182 34.757 137.284C35.873 138.437 37.9254 139.935 41.2675 141.605C47.9238 144.932 58.075 148.156 71.2774 150.947C97.551 156.501 134.22 160 174.982 160C215.743 160 252.412 156.501 278.686 150.947C291.888 148.156 302.039 144.932 308.696 141.605C312.038 139.935 314.09 138.437 315.206 137.284C315.305 137.182 315.392 137.087 315.469 137H323.963C322.7 154.166 256.482 168 174.982 168C93.481 168 27.2636 154.166 26 137H34.4939Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4939 169C34.5709 169.087 34.6582 169.182 34.757 169.284C35.873 170.437 37.9254 171.935 41.2675 173.605C47.9238 176.932 58.075 180.156 71.2774 182.947C97.551 188.501 134.22 192 174.982 192C215.743 192 252.412 188.501 278.686 182.947C291.888 180.156 302.039 176.932 308.696 173.605C312.038 171.935 314.09 170.437 315.206 169.284C315.305 169.182 315.392 169.087 315.469 169H323.963C322.7 186.166 256.482 200 174.982 200C93.481 200 27.2636 186.166 26 169H34.4939Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 68,
    x2: 30,
    y2: 170,
    stroke: "currentColor",
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 68,
    x2: 320,
    y2: 170,
    stroke: "currentColor",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 101,
    r: 5,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 134,
    r: 5,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 167,
    r: 5,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.f69b9be953f140edb86aac57cdbf0366.svg";
export { ForwardRef as ReactComponent };